import { usesSoftwareRasterizer } from './SoftwareRenderer';

export interface RendererCapabilities {
  supported: boolean;
  software: boolean;
}

/** Reuse the launch support probe to choose context attributes before Three
 * creates the real canvas. MSAA cannot be changed after context creation.
 * Only a positively identified CPU rasterizer loses multisampling; privacy-
 * masked/unknown and native drivers retain the existing anti-aliasing policy.
 * The temporary context never survives the probe, including metadata failures.
 */
export function probeRendererCapabilities(
  createCanvas: () => Pick<HTMLCanvasElement, 'getContext'> = () => document.createElement('canvas'),
): RendererCapabilities {
  let context: WebGL2RenderingContext | null = null;
  try {
    context = createCanvas().getContext('webgl2', { antialias: false });
    return { supported: context !== null, software: context !== null && usesSoftwareRasterizer(context) };
  } catch {
    return { supported: false, software: false };
  } finally {
    try { context?.getExtension('WEBGL_lose_context')?.loseContext(); }
    catch { /* Cleanup capability is optional; never turn support into a crash. */ }
  }
}
